export default __webpack_public_path__ + "static/media/1172.291eacd7.jpg";